import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    colors:{
      brand: {
        'black':'#131C4D',
        'red':'#E95353', 
        'grey':'#DCDDE4',
        'labelGrey':'#BBBECE',
        'inputGrey' : '#A6A9BC',
        'lineGrey' : '#EEEFF3',
        'navy':'#1A2A74',

      },
      hover: {
        'red':'rgba(233, 83, 83, 0.8)',
        'blue':'rgba(54, 82, 224, 0.8)',
        'black':'rgba(52, 52, 52, 0.8)',
      },
      button: {
        'black': '#343434',
        'blue': '#3652E0',
        'red': '#E95353',
        'grey': '#EDF2F7',
      }

    },
    fonts: {
      // body: 'KFAGothic',
      // heading: 'KFAGothicBold',
    },
  });

export default theme;